import { styled } from "@mui/system";
import { Button } from "@mui/material";
import COLORS from "../../../../../theme/Colors";
import FONTS_FAMILY from "../../../../../theme/FontsFamily";

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isHero',
})((props) => ({
  zIndex: 1000,
  position: props.$isHero ? 'absolute' : 'relative', // Se superpone en el hero, pero fluye normal en internas
  top: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 0',
  boxSizing: 'border-box',
  "@media (max-width: 768px)": {
    padding: '2px 0',
  },
  // Variante dinámica: Transparente en Hero, Blanco en páginas internas
  backgroundColor: props.$isHero ? 'transparent' : COLORS.white,
  boxShadow: 'none',
  color: props.$isHero ? COLORS.white : COLORS.secondary,
  transition: 'all 0.3s ease',
}));

export const LineContainer = styled('div')({
  display: 'flex',
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  width: '90%',
  maxWidth:'1920px',
  justifyContent: 'space-between',
  '@media (max-width: 768px)': {
     justifyContent: 'space-between',
  },
  '@media (min-width:320px)': {
      flexDirection: 'row',
  },
  '@media (min-width:768px)': {
      flexDirection: 'row',
  },
  '@media (min-width:1200px)': {
      flexDirection: 'row',
  }
});


export const MenuButton = styled(Button)({
  fontFamily: FONTS_FAMILY.regular.title,
  color: 'inherit',
  backgroundColor: "transparent",
  textTransform: "none",
  "@media (min-width:768px)": { fontSize: "13px" },
  "@media (min-width:1200px)": { fontSize: "16px" },
  '&:hover': { backgroundColor: COLORS.primaryOpacity(0.1) },
});


// Enlaces de navegación con estado activo y efecto hover zoom+color
export const NavLink = styled('a', {
  shouldForwardProp: (prop) => prop !== '$isHero',
})((props) => ({
  fontFamily: FONTS_FAMILY.regular.title,
  // Color dinámico: Blanco en Hero, Azul en páginas internas
  color: props.$isHero ? COLORS.white : COLORS.secondary,
  textDecoration: 'none',
  margin: '0 0.6rem',
  position: 'relative',
  display: 'inline-block',
  fontSize: '16px',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'all 0.3s ease-out',
  
  '&:hover': {
      color: `${COLORS.primary} !important`, // Forzamos el naranja para el efecto WOW
      transform: 'scale(1.1)',
  },

  '&:after': {
    content: "''",
    position: 'absolute',
    left: 0,
    bottom: '-4px',
    width: '0%',
    height: '2px',
    backgroundColor: COLORS.primary,
    transition: 'width 0.3s',
  },

  // Estado activo: texto azul en Hero (contraste) o naranja/azul en internas
  '&.active': {
    color: props.$isHero ? COLORS.primary : COLORS.primary,
    fontWeight: 700,
  },
  '&.active:after': {
    width: '100%',
    backgroundColor: COLORS.primary,
  },
}));

// Boton de registro con fondo (CTA) 
export const RegisterButton = styled('a')({
  fontFamily: FONTS_FAMILY.regular.title,
  color: COLORS.white,
  backgroundColor: COLORS.primary, // Usamos el primario (naranja) para que destaque
  textDecoration: 'none',
  padding: '0.4rem 1.2rem',
  borderRadius: '6px',
  marginLeft: '0.8rem',
  fontSize: '15px',
  fontWeight: 600,
  display: 'inline-block',
  cursor: 'pointer',
  transition: 'all 0.3s ease-out',
  
  '&:hover': {
      backgroundColor: COLORS.secondary, // Cambia a azul en hover
      transform: 'scale(1.05)',
  },
});

export const DrawerMenuContainer = styled("div")({
  display: "flex",
  zIndex: 1000,
  position: "absolute",
  flexDirection: "row",
  alignSelf: "flex-end",
  alignItems: "center",
  top: 0,
  right: 0,
  marginTop: "0",
});

export const Image = styled("img")({
  ':hover': { 
      cursor: 'pointer',
      transform: 'scale(1.02)',
  },
  transition: 'transform 0.3s ease',
  marginLeft: '3rem', 
  marginTop: '0.60rem',
  "@media (min-width:320px)": { width: "140px", marginBottom: "5px" },
  "@media (min-width:768px)": { width: "180px" },
  "@media (min-width:1200px)": { width: "240px" },
});
